<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="customerActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheCustomerActivityPage',
  computed: {
    ...mapGetters({ customerActivity: 'customer/getCustomerActivity' })
  },
  methods: {
    ...mapActions({ fetch: 'customer/fetchCustomerActivitiesByCustomerID' })
  },
  beforeMount() {
    this.fetch({ customer_id: this.$route.params.id })
  }
}
</script>
